<template>
  <v-app v-resize="updateWindowHeight">
    <router-view/>
  </v-app>
</template>

<script>
import { mapState, mapWritableState } from "pinia"
import { useDisplayStore, useSettingsStore } from "./store/index"

export default {
  provide(){
    return {
        changeLanguageFn: this.changeLanguage
    }
  },
  watch: {
    breakpoint: {
      handler (newValue) {
        this.setBreakpoint(newValue)
      }
    },
    'fontsSetting.fontsize'(){
      this.applyFontSize()
    }
  },
  mounted () {
    this.setBreakpoint(this.breakpoint)
    this.applyFontSize()
  },
  data () {
    return {
      fontsSetting: useSettingsStore(),
      tab: 0,
      menus: [
        //{ label: "API Documentation", to: "/api-doc", disabled: true  },
        //{ label: "API Test in-place", to: "/api-sandbox", disabled: true  },
        //{ label: "Monitoring (TBR)", disabled: true },
        //{ label: "IP Allowlist (TBR)", disabled: true },
        //{ label: "Session (TBR)", disabled: true },
        //{ label: "Notifications (TBR)", disabled: true }
      ],
      panel: undefined
    }
  },
  computed: {
    ...mapWritableState(useDisplayStore, {
      breakpointState: "breakpoint",
      windowHeightState: "windowHeight",
    }),
    ...mapState(useDisplayStore, [
      "isXSmall",
      "isSmall",
      "isMedium",
      "isLarge",
      "isXLarge"
    ]),
    breakpoint () {
      return this.$vuetify.breakpoint.name
    }
  },
  methods: {
    changeLanguage(lang) {
      this.$i18n.locale = lang
      localStorage.setItem('userLanguage', lang)
  },
    setBreakpoint (value) {
      this.breakpointState = value
    },
    updateWindowHeight () {
      this.windowHeightState = window.innerHeight
    },
    applyFontSize() {
      const scale = this.fontsSetting.getFontSize
      document.documentElement.style.setProperty(
    'font-size',
    `${15 * scale}px`,
    'important'
  )
    }
  }
}
</script>

<style scoped>
@font-face {
  font-family: AvenirNextM-Regular;
  src: url("~@/assets/fonts/AvenirNextM-Regular.ttf");
}
</style>
<style>
  html{
  font-size: 16px !important;
  }
:root {
  --app-font-size: 12px !important;
}

.v-application .v-btn,
.v-application .v-menu,
.v-application .v-data-table,
.v-application .v-card,
.v-application .v-list-item,
.v-application .v-toolbar,
.v-application .v-data-table,
.v-application .v-tabs,
.v-application .v-chip,
.v-application span,
.v-application .v-cols,
.v-application .v-card,
.v-application .v-card-title,
.v-application p
{
  font-size: var(--app-font-size) !important;
}
/** deifine min resolution */
.v-app{
  min-height: 768px; 
  min-width: 1024px;
}

.partner-chip {
  /*
  GREEN - border : #008000  BG: #0080005e 
  YELLOW - border #ffb000  BG: #f4c54240
  */
  background-color: #3789ec5e !important;
  border: 1px solid #0073ff !important;
  color: white !important;
}

.short-id {
  max-width: 100px;
  font-size: 11px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: bottom;
}
.copy-icon {
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}
.copy-icon:hover{
  opacity: 1;
}
.small-line-radio{
    transform: scale(.8);
    text-wrap: nowrap !important;
    flex-wrap: nowrap !important;
}
.v-snack--absolute,
.v-snack--fixed {
  z-index: 2400 !important;
}
.disabled-text{
  color:#515151;
}
.input-title-text{
  color:rgba(255, 255, 255, 0.7);
}

.toggle-over-button {
  border: 1px solid #0073ff6d !important;
  background:rgb(27, 27, 27) !important;
  border-radius: 12px !important;
}
</style>